const initVisitTracking = (doctype, docid, corpid) => {
    const start = Date.now() / 1000;
    const handleBeforeUnload = () => {
        const end = Date.now() / 1000;
        const duration = end - start;
        navigator.sendBeacon(
            '/tracking/visit',
            JSON.stringify({
                doctype,
                docid,
                corpid,
                duration,
                start,
                end,
            }),
        );
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
    };
};

const trackDownload = (doctype, docid, corpid) => {
    const params = new URLSearchParams({ doctype, docid, corpid });
    fetch('/tracking/download', {
        method: 'POST',
        body: params,
    });
};

export { initVisitTracking, trackDownload };
